export default __webpack_public_path__ + "static/media/img-7.320806a1.jpg";